export default __webpack_public_path__ + "static/agcsite-7e1676770f4183955a88c8d725e3df6d.png";